<template>
  <div>
    <eg-b-button
      v-if="!value"
      v-b-toggle.rubric-library-sidebar
      variant="outline-info"
      size="sm"
    >
      {{ $t("rubrics.selectFromLibrary") }}
    </eg-b-button>
    <div v-if="value" class="d-flex align-items-start">
      <div>
        <div class="rubric-name">{{ value?.name }}</div>
        <div class="rubric-created-by">
          {{ $t("rubrics.createdBy") }}
          <b>
            {{ formatAuthorValue(value?.author, $store) || $t("rubrics.me") }}
          </b>
        </div>
      </div>
      <eg-b-button
        v-if="value"
        v-b-toggle.rubric-library-sidebar
        class="ml-4"
        variant="outline-info"
        size="sm"
      >
        {{ $t("rubrics.selectDifferentRubric") }}
      </eg-b-button>
    </div>
    <rubric-library
      v-model="selectedRubric"
      show-add-new
      @input="selectRubric"
    />
  </div>
</template>

<script>
import RubricLibrary from "@/components/rubrics/rubric_library.vue";
import { formatAuthorValue } from "@/utils/format";

export default {
  components: {
    RubricLibrary,
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ["value"],
  emits: ["input"],
  data() {
    return {
      selectedRubric: null,
    };
  },

  watch: {
    value: {
      handler(newValue) {
        if (newValue && newValue.id) {
          this.selectedRubric = newValue;
        }
      },
      immediate: true,
    },
  },

  methods: {
    formatAuthorValue,

    selectRubric(rubric) {
      this.$emit("input", rubric);
    },
  },
};
</script>

<style lang="scss">
.rubric-name {
  color: var(--Text-Body, #212529);
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}

.rubric-created-by {
  color: var(--Text-Body, #212529);
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
}
</style>
